import { useEffect } from 'react';
import { useServicesVideo } from './useServicesVideo';

export const BenefitsPoster = () => <picture className="benefits-static-poster" data-testid="benefits-deferred-poster">
  <source media="(max-width: 760px)" srcSet="/media/benefits-poster-mobile.webp" />
  <img src="/media/benefits-poster-desktop.webp" alt="" width="1280" height="720" loading="lazy" />
</picture>;

export const BenefitsBackground = () => {
  const { videoRef, source, poster, canRun, playing, hasPlayed, onPlaying, onPause, onError } = useServicesVideo({
    assetName: 'betaris-benefits', posterName: 'benefits-poster',
  });

  useEffect(() => {
    const video = videoRef.current;
    return () => {
      if (!video) return;
      video.pause(); video.removeAttribute('src'); video.load();
    };
  }, [videoRef, source]);

  return <>
    <video key={source || 'benefits-still'} ref={videoRef} id="betaris-benefits-video" data-testid="benefits-video" className="benefits-background-video"
      src={source || undefined} poster={poster} autoPlay={canRun} muted loop playsInline preload="none" tabIndex={-1}
      width="1280" height="720" onPlaying={onPlaying} onPause={onPause} onError={onError}
      disablePictureInPicture disableRemotePlayback controlsList="nodownload nofullscreen noremoteplayback" aria-hidden="true" />
    <img src={poster} alt="" width="1280" height="720" loading="lazy" data-testid="benefits-video-poster"
      className={`benefits-video-poster${hasPlayed ? ' has-played' : ''}`} aria-hidden="true" />
    <span className="sr-only" data-testid="benefits-video-status">{playing ? 'Der Hintergrund läuft stumm in Endlosschleife.' : 'Unbewegtes Vorschaubild des Hintergrunds.'}</span>
  </>;
};